export default __webpack_public_path__ + "static/media/1.846e246f.webp";